import { render, staticRenderFns } from "./document-alert-outline.vue?vue&type=template&id=4c641501&scoped=true"
var script = {}
import style0 from "./document-alert-outline.vue?vue&type=style&index=0&id=4c641501&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c641501",
  null
  
)

export default component.exports